import React, { useState, useEffect } from 'react'
import HeaderAdmin from "../Components/HeaderAdmin/Header";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";
import { Link } from "react-router-dom";
import { IoClose, IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { MdOutlineModeEdit } from 'react-icons/md';
import Spinner from 'react-bootstrap/Spinner';
import { useParams } from 'react-router-dom';
import { addnotes, getnotes } from "../Api/prescriptionApis"
import {
    getfitterbyid, updateStaff, updatestaffstage, updatestaffrole, updatestafflocation, staffassignkit, sendvarificationbuilder, removebuilderfitter, getcountriesforfitter,
    getstates, getcities, getassignkit
} from '../Api/iron'
import { TfiReload } from "react-icons/tfi";
import Modal from 'react-bootstrap/Modal';
import { getCurrentUser } from "../Api/auth";
import Button from 'react-bootstrap/Button';
import { MdMarkEmailRead } from "react-icons/md";



function FitterBuilderView() {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const toggleDropdown3 = () => {
        setIsOpen3(!isOpen3);
    };

    const toggleDropdown4 = () => {
        setIsOpen4(!isOpen4);
    };

    const toggleDropdown5 = () => {
        setIsOpen5(!isOpen5);
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option.text);
        setSelectionId(option.id);
    };

    const selectOption3 = (option) => {
        setSelectedOption3(option.text);
        setSelectRoleId(option.id);
    };

    const selectOption4 = (option) => {
        setSelectedOption4(option.text);
        setSelectKitId(option.id);
    };

    const selectOption5 = (option) => {
        setSelectedOption5(option.text);
        setSelectLocationId(option.id)
    };

    const getColorClass = () => {
        const selectedColor = options2.find(opt => opt.text === selectedOption2)?.color;
        return selectedColor ? selectedColor : 'white';
    };

    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen5, setIsOpen5] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState('Inquiry');
    const [selectedOption3, setSelectedOption3] = useState('Assign Role');
    const [selectedOption4, setSelectedOption4] = useState('Assign Kit');
    const [selectedOption5, setSelectedOption5] = useState('Assign Location');

    const [selectionid, setSelectionId] = useState(0);
    const [selectroleid, setSelectRoleId] = useState(0);
    const [selectkitid, setSelectKitId] = useState(0);
    const [selectlocationid, setSelectLocationId] = useState(0);

    const [dbselectionid, setdbselectionid] = useState(0);
    const [dbselectroleid, setdbselectroleid] = useState(0);
    const [dbselectkitid, setdbselectkitid] = useState(0);
    const [dbselectlocationid, setdbselectlocationid] = useState(0);

    const [apicallupate, setApicallupdate] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);


    const handlegetnotes = () => {
        const data = {
            project_id: params.id
        }
        getnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setnotesData(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setValidated(true);
        });
    };

    const handleaddnotes = () => {
        setApicall(true);

        if (notes === "") {
            setShowererror(true);
            setApicall(false);
            return false;
        }

        const data = {
            notes: notes,
            user_id: userid,
            fitter_id: userid,
            project_id: params.id
        }

        addnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setShowererror(false);
            setApicall(false);
            setValidated(true);
            setnotes('');
        });
    };

    const [notes, setnotes] = useState('');
    const [showerror, setShowererror] = useState(false);
    const [apicall, setApicall] = useState(false);
    const [notesdata, setnotesData] = useState([]);

    const options2 = [
        { text: 'Inquiry', color: 'orange', id: 0 },
        { text: 'Contacted', color: 'yellow', id: 1 },
        { text: 'Invoiced', color: 'green', id: 2 },
        { text: 'Purchased', color: 'blue', id: 3 }
    ];

    const options3 = [
        { text: 'Fitter / Builder', color: 'orange', id: 8 },
        { text: 'Fitter / Coach', color: 'yellow', id: 1 },
        { text: 'Fitter / Party', color: 'blue', id: 10 },
    ];

    const options4 = [
        { text: 'Righty', id: 0 },
        { text: 'Lefty', id: 1 },
        { text: 'TPT', id: 3 },
        { text: 'Tall', id: 4 },
        { text: 'Junior', id: 5 },
        { text: 'Biz Dev', id: 6 },
    ];

    // const [options4, setoptions4] = useState([]);

    const options5 = [
        { id: 0, text: 'Domestic', color: 'purple' },
        { id: 1, text: 'International', color: 'blue' },
    ];

    const getassignkitname = (kitname) => {
        switch (kitname) {
            case 0:
                return "Righty";
            case 1:
                return "Lefty";
            case 3:
                return "TPT";
            case 4:
                return "Tall";
            case 5:
                return "Junior";
            case 6:
                return "Biz Dev";
            default:
                return "Assign Kit";
        }

    }

    const params = useParams();
    const [userid, setUserid] = useState(0);
    const [fitter_id, setFitter_id] = useState(0);
    const [validated, setValidated] = useState(false);

    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        website: "",
        shippingaddress: "",
        business_name: "",
        city: "",
        state: "",
        country: "",
        bio: "",
        zip: ""
    });

    const [isEditing, setIsEditing] = useState(false);

    const setEditable = () => {
        setIsEditing(!isEditing);
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const getfitterdetailsfunc = () => {
        setIsLoading(true);

        const data = {
            _id: params.id
        }
        getfitterbyid(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setFormData({
                    firstname: data.firstname,
                    lastname: data.lastname,
                    website: data.website_url,
                    shippingaddress: data.shipping_address,
                    email: data.email,
                    phone: data.phone,
                    business_name: data.business_name,
                    country: data.country,
                    state: data.state,
                    city: data.city,
                    bio: data.bio,
                    zip: data.zip,

                });
                setSelectedOption2(getstatusname(data?.stage))
                setSelectionId(data.status);
                setdbselectionid(data.status);

                setSelectedOption3(data?.role_id === 9 ? "Assign Role" : data?.role_id === 8 ? "Fitter / Builder" : data?.role_id === 10 ? "Fitter / Party" : "Fitter / Coach");
                setSelectRoleId(data.role_id);
                setdbselectroleid(data.role_id);

                setSelectedOption4(data?.assign_kit === 2 ? "Assign Kit" : getassignkitname(data?.assign_kit));
                setSelectKitId(data.assign_kit);
                setdbselectkitid(data.assign_kit);

                setSelectedOption5(data?.location === 2 ? "Assign Location" : data?.location === 0 ? "Domestic" : "International");
                setSelectLocationId(data.location);
                setdbselectlocationid(data.location);

                setFitter_id(data.fitter_id);
                getallstatefunc(data.country);
                getallcityfunc(data.state);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            // setValidated(true);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        getfitterdetailsfunc();
        getallcountry();
        handlegetnotes();
        getassignkitfunc();

        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserid(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }
    }, []);

    const getassignkitfunc = () => {
        // getassignkit().then((response) => {
        //     if (!response.data.status) {
        //         console.log(response.data.message);
        //     } else {
        //         const data = response.data.data;
        //         setoptions4(data);
        //     }
        // }).catch((err) => {
        //     console.log(err);
        // });
    }

    const [apiupate, setApiupdate] = useState(false);

    const handleupdatedata = () => {
        setApiupdate(true);
        const data = {
            _id: params.id,
            firstname: formData.firstname,
            lastname: formData.lastname,
            email: formData.email,
            phone: formData.phone,
            website_url: formData.website,
            shipping_address: formData.shippingaddress,
            business_name: formData.business_name,
            country: formData.country,
            state: formData.state,
            city: formData.city,
            bio: formData.bio || "",
            // zip: formData.zip || "",
            zip: formData.zip,
            address: formData.shippingaddress,
        }


        updateStaff(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApiupdate(false);
                setIsEditing(false);
                getfitterdetailsfunc();
                handleShow();
            }
        }
        ).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApiupdate(false);
            setValidated(true);
        });
    }

    const getstatusname = (status) => {
        switch (status) {
            case 0:
                return 'Inquiry';
            case 1:
                return 'Contacted';
            case 2:
                return 'Invoiced';
            case 3:
                return 'Purchased';
            default:
                return 'Unknown'; // In case the status doesn't match any case
        }
    }


    const updateStagestatus = (e) => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            stage: selectionid
        }

        updatestaffstage(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApicallupdate(false);
                getfitterdetailsfunc();
                handleShow();
                toggleDropdown2();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const updatefitterrole = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            role_id: selectroleid
        }

        updatestaffrole(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApicallupdate(false);
                getfitterdetailsfunc();
                handleShow();
                toggleDropdown3();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const updateassingkit = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            assign_kit: selectkitid
        }

        staffassignkit(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApicallupdate(false);
                getfitterdetailsfunc();
                handleShow();
                toggleDropdown4();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const updatestafflocationfunc = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            location: selectlocationid
        }

        updatestafflocation(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApicallupdate(false);
                getfitterdetailsfunc();
                handleShow();
                toggleDropdown5();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };


    const handleCloseConfirmation2 = () => setShowConfirmation2(false);
    const handleShowConfirmation2 = () => setShowConfirmation2(true);
    const [showConfirmation2, setShowConfirmation2] = useState(false);

    const [emailloader, setEmailLoader] = useState(false);

    const sendvarificationfunc = () => {
        setEmailLoader(true);
        const data = {
            email: params.id,
        }

        sendvarificationbuilder(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setEmailLoader(false);
                handleCloseConfirmation2();
                // window.location.href = '/remote_inquirie';
            }
        }).catch((err) => {
            console.log(err);
        });


    }


    const handleCloseConfirmation3 = () => setShowConfirmation3(false);
    const handleShowConfirmation3 = () => setShowConfirmation3(true);
    const [showConfirmation3, setShowConfirmation3] = useState(false);

    const [removeloader, setRemoveloader] = useState(false);

    const removebuilderfitterfunc = () => {
        setRemoveloader(true);
        handleCloseConfirmation3();
        const data = {
            _id: params.id,
        }
        removebuilderfitter(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                window.location.href = '/fitter_application';
            }
        }
        ).catch((err) => {
            console.log(err);
        }).finally(() => {
            setRemoveloader(false);
            setValidated(true);
        });
    }

    const [countrylist, setCountrylist] = useState([]);
    const [statelist, setStatelist] = useState([]);
    const [citylist, setCitylist] = useState([]);

    const getallcountry = () => {
        getcountriesforfitter()
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCountrylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallstatefunc = (country_id) => {
        const data = {
            country_id: country_id,
        };
        getstates(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setStatelist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallcityfunc = (state_id) => {
        const data = {
            state_id: state_id,
        };
        getcities(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCitylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <Modal
                            show={show} // Show the modal when `show` is true
                            onHide={handleClose}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Data update successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation2}
                            onHide={handleCloseConfirmation2}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to resend email?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        <Button variant="success" onClick={sendvarificationfunc} style={{ maxWidth: "3.5rem" }}>
                                            {
                                                emailloader ? <Spinner animation="border" className="border-black" /> : <span>Yes</span>
                                            }
                                        </Button>
                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation2();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation3}
                            onHide={handleCloseConfirmation3}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove fitter?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        <Button variant="success" onClick={removebuilderfitterfunc} style={{ maxWidth: "3.5rem" }}>Yes
                                        </Button>
                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation3();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>
                        <div className='design_show_mobile'>
                            <div className='fixed-btn'>
                                <Link to="/fitter-customer">
                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#1e2024"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                </Link>
                            </div>
                        </div>

                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_text_content">
                                                                    <div className="big_text">Fitter Application</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <div className="header-left">
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                                                            <div className='black_bg_box mt-0'>
                                                                <div class="add-golfer-header">
                                                                    <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                        <h3>Fitter Application</h3>
                                                                    </div>
                                                                    <div>
                                                                        {
                                                                            isEditing ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Submit"
                                                                                    onClick={handleupdatedata}
                                                                                >
                                                                                    {apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />}
                                                                                </button>
                                                                            ) : (
                                                                                <>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-close me-3"
                                                                                        aria-label="Close"
                                                                                        onClick={() => {
                                                                                            handleShowConfirmation2();
                                                                                        }}
                                                                                    >
                                                                                        <MdMarkEmailRead />
                                                                                    </button>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-close me-3"
                                                                                        aria-label="Close"
                                                                                        onClick={() => setEditable(true)}
                                                                                    >
                                                                                        <MdOutlineModeEdit />
                                                                                    </button>
                                                                                </>

                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className='modal-long-form'>
                                                                    <Form noValidate>
                                                                        <div className="row gap-4">
                                                                            <div className='row pe-0' controlid="validationCustom011">
                                                                                <div className='col-6 col-md-6 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="First Name" required name="firstname" value={formData.firstname} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className='col-6 col-md-6 md-5 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="Last Name" required name="lastname" value={formData.lastname} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom019">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="Business Name" required name="business_name" value={formData.business_name} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom013">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="Phone" required name="phone" value={formData.phone} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom014">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="email" class="form-control dashboard-input-box-3" placeholder="Email" required name="email" value={formData.email} onChange={handleFormChange} disabled={!isEditing} />

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom015">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Website" style={{ height: "100px" }} required name="website" value={formData.website} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Shipping Address" style={{ height: "100px" }} required name="shippingaddress" value={formData.shippingaddress} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        {/* <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Pleascountry" style={{ height: "100px" }} required name="country" value={formData.country} onChange={handleFormChange} disabled={!isEditing} /> */}
                                                                                        <select name="country" disabled={!isEditing} value={formData.country} onChange={(e) => {
                                                                                            handleFormChange(e);
                                                                                            getallstatefunc(
                                                                                                e.target.value
                                                                                            );
                                                                                            setFormData((prev) => ({
                                                                                                ...prev,
                                                                                                state: "", // reset state
                                                                                                city: "",  // reset city
                                                                                            }));
                                                                                        }}
                                                                                            class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                                            aria-label="Default select example"
                                                                                        >
                                                                                            <option value={0}>
                                                                                                Country
                                                                                            </option>
                                                                                            {countrylist &&
                                                                                                countrylist.map(
                                                                                                    (item) => (
                                                                                                        <option
                                                                                                            value={item._id}
                                                                                                            key={item._id}
                                                                                                        >
                                                                                                            {item.name}
                                                                                                        </option>
                                                                                                    )
                                                                                                )}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        {/* <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Shipping Address" style={{ height: "100px" }} required name="state" value={formData.state} onChange={handleFormChange} disabled={!isEditing} /> */}
                                                                                        <select name="state" disabled={!isEditing} value={formData.state} onChange={(e) => {
                                                                                            handleFormChange(e);
                                                                                            getallcityfunc(
                                                                                                e.target.value
                                                                                            );
                                                                                        }}
                                                                                            class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                                            aria-label="Default select example"
                                                                                        >
                                                                                            <option value={0}>
                                                                                                State
                                                                                            </option>
                                                                                            {statelist &&
                                                                                                statelist.map((item) => (
                                                                                                    <option
                                                                                                        value={item._id}
                                                                                                        key={item._id}
                                                                                                    >
                                                                                                        {item.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        {/* <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Shipping Address" style={{ height: "100px" }} required name="city" value={formData.city} onChange={handleFormChange} disabled={!isEditing} /> */}
                                                                                        <select name="city" disabled={!isEditing} value={formData.city} onChange={(e) => {
                                                                                            handleFormChange(e);
                                                                                        }}
                                                                                            class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                                            aria-label="Default select example"
                                                                                        >
                                                                                            <option value={0}>
                                                                                                City/Town
                                                                                            </option>
                                                                                            {citylist &&
                                                                                                citylist.map((item) => (
                                                                                                    <option
                                                                                                        value={item._id}
                                                                                                        key={item._id}
                                                                                                    >
                                                                                                        {item.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="Zip" required name="zip" value={formData.zip} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Bio..." style={{ height: "100px" }} required name="bio" value={formData.bio} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Form>
                                                                </div>
                                                            </div>

                                                            <div className="btn-box-section btn-inline-box">
                                                                {
                                                                    removeloader ? (<button className="btn btn-primary btn-remove" disabled>Removing...</button>) : (<button className="btn btn-primary btn-remove" onClick={handleShowConfirmation3}>Remove Fitter</button>)
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ">
                                                            <div className="fix_sec_view">
                                                                {/* role Dropdown */}
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen3 ? 'open' : ''}`}>
                                                                        <div className='select-option-inner' onClick={toggleDropdown3} >
                                                                            <div className='selected-option-text'>{selectedOption3}</div>
                                                                            <span className={`icon ${isOpen3 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen3 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options3.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption3 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption3(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        // selectedOption2 === "Inquiry" || selectionid === dbselectionid ? (
                                                                                        selectroleid === dbselectroleid ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updatefitterrole}
                                                                                            >

                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* kit Dropdown */}
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen4 ? 'open' : ''}`}>
                                                                        <div className='select-option-inner' onClick={selectedOption4 !== "Assign Kit" ? null : toggleDropdown4} >
                                                                            <div className='selected-option-text'>{selectedOption4}</div>
                                                                            <span className={`icon ${isOpen4 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen4 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options4.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption4 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption4(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        // selectedOption2 === "Inquiry" || selectionid === dbselectionid ? (
                                                                                        selectkitid === dbselectkitid ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updateassingkit}
                                                                                            >

                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Location  Dropdown*/}
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen5 ? 'open' : ''}`}>
                                                                        <div className='select-option-inner' onClick={toggleDropdown5} >
                                                                            <div className='selected-option-text'>{selectedOption5}</div>
                                                                            <span className={`icon ${isOpen5 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen5 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options5.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption5 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption5(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        selectlocationid === dbselectlocationid ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updatestafflocationfunc}
                                                                                            >

                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Stage Dropdown */}
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                        <div className='select-option-inner' onClick={toggleDropdown2} >
                                                                            <span className={`icon-color color-${getColorClass()}`}></span>
                                                                            <div className='selected-option-text'>{selectedOption2}</div>
                                                                            <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen2 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options2.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption2(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-icon'>
                                                                                                <span className={`icon-color color-${option.color}`}> </span>
                                                                                            </div>
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        (selectedOption2 === "Inquiry" || (selectedOption2 === "Purchased" &&
                                                                                            (selectroleid === 9 || selectkitid === 2 || selectlocationid === 2))) ? (
                                                                                            <button className="btn btn-primary btn-create" disabled>
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button className="btn btn-primary btn-create" onClick={updateStagestatus}>
                                                                                                {apicallupate ? (
                                                                                                    <Spinner animation="border" className="border-black" />
                                                                                                ) : (
                                                                                                    <span>Update Status</span>
                                                                                                )}
                                                                                            </button>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className='design_hide_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" value={notes} onChange={(e) => setnotes(e.target.value)} placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}><span>{apicall ? <Spinner animation="border" className="border-black" /> : "Add Note"}</span></button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                                <div className='design_show_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={notes} onChange={(e) => setnotes(e.target.value)} rows="10" placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}><span>{apicall ? <Spinner animation="border" className="border-black" /> : "Add Note"}</span></button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <style>
                            {`
                                .btn-remove{
                                    border-radius: 15px !important;
                                    color: #ffffff !important;
                                }
                                .form-select:disabled {
                                    background-color: #41464f !important;
                                    pointer-events: none !important;
                                }
                                
                                @media only screen and (min-width: 991px){
                                .right_fix_sec {    
                                    height: calc(100vh - 300px);
                                    transition: .3s;
                                    right: 0;
                                    overflow-y: auto;
                                }
                                    .dashboard_first {
                                    flex: 0 0 640px;
                                    max-width: 640px;
                                    width: 100%;
                                }
                            }
                                // @media only screen and (min-width: 1601px) and (max-width: 1919px) {
                                //     .dashboard_first {
                                //         flex: 0 0 640px; 
                                //         max-width: 640px; 
                                //         width: 100%; 
                                //     }
                                // }
                            `}
                        </style>
                    </>
                )
            }
        </>
    )
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

export default FitterBuilderView
